import React, { useState, useContext, useEffect } from 'react';
import { ErpContext } from '../../context/ErpContext.js';
import { useParams } from 'react-router-dom';
import { useTenantNavigation } from '../../hooks/useTenantNavigation';
import imgLutenteNav from '../../assets/images/LutenteNavTransparent.png';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  IconButton,
  InputAdornment,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { styled } from '@mui/material/styles';
import Cookies from 'js-cookie';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: '400px',
  margin: 'auto',
  textAlign: 'center',
  boxShadow: theme.shadows[5],
  borderRadius: '12px',
}));

const LoginComponent = () => {
  const { tenant } = useParams();
  const navigate = useTenantNavigation();

  const { login, tenantContext } = useContext(ErpContext);
  const [formData, setFormData] = useState({ usuario: '', password: '', tenant: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false); // toggle del "ojito" para ver la contraseña

  // 🌐 Usar tenant de URL o cookie persistente como fallback
  useEffect(() => {
    // Prioridad: tenant de URL > tenantURL de cookie > tenantContext
    const tenantToUse = tenant || Cookies.get('tenantURL') || tenantContext;

    console.log('🔍 Tenant detectado:', {
      fromURL: tenant,
      fromCookie: Cookies.get('tenantURL'),
      fromContext: tenantContext,
      final: tenantToUse,
    });

    if (tenantToUse) {
      setFormData((prevState) => ({
        ...prevState,
        tenant: tenantToUse,
      }));
    }
  }, [tenant, tenantContext]);

  // Redirigir a URL con tenant si no está en la URL
  useEffect(() => {
    const currentTenant = tenant || Cookies.get('tenantURL');

    if (!tenant && currentTenant) {
      // Si no hay tenant en URL pero existe en cookie, redirigir
      // Usar solo el path sin tenant, el hook lo agregará
      navigate(`login`, { replace: true });
    }
  }, [tenant, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log('🔐 Iniciando sesión con tenant:', formData.tenant);
      await login(formData);

      // 🌐 Redirigir usando tenantURL (ahora guardado en cookies persistentes)
      // El hook agregará automáticamente el tenant
      navigate(''); // Redirige al dashboard (/:tenant/)
    } catch (err) {
      setError(err.response?.data?.message || 'Error en el inicio de sesión.');
    }
  };

  return (
    <Container
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <StyledPaper elevation={6}>
        <Box display="flex" justifyContent="center" mb={2}>
          <img className="imgLutenteNav titleLutenteNav" src={imgLutenteNav} alt="" />
        </Box>
        <Typography variant="h5" component="h1" mb={3} fontWeight="bold">
          Iniciar Sesión
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Usuario"
            name="usuario"
            variant="outlined"
            fullWidth
            margin="normal"
            onChange={handleChange}
            required
          />
          <TextField
            label="Contraseña"
            name="password"
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            fullWidth
            margin="normal"
            onChange={handleChange}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    onClick={() => setShowPassword((v) => !v)}
                    onMouseDown={(e) => e.preventDefault()} // no perder el foco del input al clickear
                    edge="end"
                    // App.css fuerza `.ManagerDiv button svg { color: naranja }` — hay que
                    // pintar el SvgIcon (más específico) o el gris no se ve.
                    sx={{ color: '#5b5b5f', '& svg': { color: '#5b5b5f !important' } }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {error && (
            <Typography color="error" variant="body2" mt={1} mb={2}>
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: '1rem', fontWeight: 'bold' }}
          >
            Iniciar Sesión
          </Button>
        </form>
      </StyledPaper>
    </Container>
  );
};

export default LoginComponent;
